/**
 * Basecamp Comment Styles Component
 * Extracted styles for Basecamp todo descriptions and comments
 */

export function BasecampCommentStyles() {
  return (
    <style>{`
      /* Description content - ensure high contrast */
      .basecamp-todo-description {
        color: hsl(var(--foreground)) !important;
      }
      .basecamp-todo-description p {
        color: hsl(var(--foreground)) !important;
        opacity: 0.95;
        margin: 0;
      }
      /* A blank line is the bc-spacer class (see collapseBlankLineSpacers). Neighboring
         paragraphs stay flush so their margins do not add a second gap. */
      .basecamp-todo-description p + p:not(.bc-spacer) {
        margin-top: 0.25rem;
      }
      .basecamp-todo-description .bc-spacer,
      .basecamp-todo-description .bc-spacer + p {
        margin-top: 0;
      }
      .basecamp-todo-description .bc-spacer {
        height: 0.75rem;
      }

      /* Chill Basecamp "large"/h1-h3 headings so they don't dominate narrow preview panes.
         Matches body scale (prose-sm) while keeping section hierarchy via weight + spacing. */
      .basecamp-todo-description h1,
      .basecamp-todo-description h2,
      .basecamp-todo-description h3,
      .basecamp-todo-description h4,
      .basecamp-todo-description h5,
      .basecamp-todo-description h6 {
        font-weight: 600;
        line-height: 1.35;
        color: hsl(var(--foreground));
      }
      .basecamp-todo-description h1,
      .basecamp-todo-description h2 {
        font-size: 0.875rem; /* text-sm - Basecamp "large" / medium */
        margin-top: 0.75rem;
        margin-bottom: 0.25rem;
      }
      .basecamp-todo-description h3 {
        font-size: 0.8125rem;
        margin-top: 0.625rem;
        margin-bottom: 0.25rem;
      }
      .basecamp-todo-description h4,
      .basecamp-todo-description h5,
      .basecamp-todo-description h6 {
        font-size: 0.75rem;
        margin-top: 0.5rem;
        margin-bottom: 0.125rem;
      }
      .basecamp-todo-description h1:first-child,
      .basecamp-todo-description h2:first-child,
      .basecamp-todo-description h3:first-child {
        margin-top: 0;
      }

      .basecamp-comment-content {
        color: hsl(var(--foreground));
      }
      .basecamp-comment-content p {
        margin: 0;
        line-height: 1.6;
      }
      .basecamp-comment-content p + p:not(.bc-spacer) {
        margin-top: 0.25rem;
      }
      .basecamp-comment-content .bc-spacer,
      .basecamp-comment-content .bc-spacer + p {
        margin-top: 0;
      }
      .basecamp-comment-content .bc-spacer {
        height: 0.75rem;
      }
      .basecamp-comment-content a {
        color: hsl(var(--primary));
        text-decoration: underline;
        text-decoration-color: hsl(var(--primary) / 0.4);
        text-underline-offset: 2px;
        transition: color 0.2s;
      }
      .basecamp-comment-content a:hover {
        color: hsl(var(--primary) / 0.8);
        text-decoration-color: hsl(var(--primary) / 0.6);
      }
      .basecamp-comment-content code {
        background-color: hsl(var(--muted));
        color: hsl(var(--foreground));
        border-radius: 0.25rem;
        padding: 0.125rem 0.375rem;
        font-family: ui-monospace, SFMono-Regular, Monaco, monospace;
        font-size: 0.875em;
      }
      .basecamp-comment-content pre {
        background-color: hsl(var(--muted));
        border: 1px solid hsl(var(--border));
        border-radius: 0.5rem;
        padding: 1rem;
        overflow-x: auto;
        margin: 1rem 0;
      }
      .basecamp-comment-content pre code {
        background: none;
        padding: 0;
        color: inherit;
      }
      .basecamp-comment-content ul,
      .basecamp-comment-content ol,
      .basecamp-todo-description ul,
      .basecamp-todo-description ol {
        margin: 0.15rem 0;
        padding-left: 1.5rem;
      }
      .basecamp-comment-content li,
      .basecamp-todo-description li {
        margin: 0.1rem 0;
      }
      .basecamp-comment-content li > p,
      .basecamp-todo-description li > p,
      .basecamp-comment-content li > p + p,
      .basecamp-todo-description li > p + p {
        margin: 0;
      }
      .basecamp-comment-content blockquote {
        border-left: 4px solid hsl(var(--border));
        padding-left: 1rem;
        margin: 1rem 0;
        color: hsl(var(--muted-foreground));
        font-style: italic;
      }
      .basecamp-comment-content strong {
        font-weight: 600;
        color: hsl(var(--foreground));
      }
      .basecamp-comment-content em {
        font-style: italic;
      }
      .basecamp-comment-content img {
        max-width: 100%;
        height: auto;
        border-radius: 0.5rem;
        margin: 1rem 0;
      }
      .basecamp-todo-description img,
      .basecamp-comment-content img {
        max-width: 100%;
        height: auto;
      }
      .basecamp-todo-description .bc-image-attachment,
      .basecamp-comment-content .bc-image-attachment {
        margin: 0.75rem 0;
        max-width: 100%;
      }
      .basecamp-todo-description .bc-image-attachment img,
      .basecamp-comment-content .bc-image-attachment img {
        display: block;
        width: 100%;
        max-width: 100%;
        height: auto;
        margin: 0;
        border-radius: 0.5rem;
        border: 1px solid hsl(var(--border));
        background: hsl(var(--muted) / 0.35);
        min-height: 8rem;
      }
      .basecamp-todo-description .bc-image-attachment[data-bc-image-failed] img,
      .basecamp-comment-content .bc-image-attachment[data-bc-image-failed] img {
        min-height: 0;
        opacity: 0.4;
      }
      .basecamp-todo-description .bc-image-attachment figcaption,
      .basecamp-comment-content .bc-image-attachment figcaption {
        margin-top: 0.35rem;
        font-size: 0.75rem;
        color: hsl(var(--muted-foreground));
      }
      .basecamp-comment-content h1,
      .basecamp-comment-content h2,
      .basecamp-comment-content h3,
      .basecamp-comment-content h4,
      .basecamp-comment-content h5,
      .basecamp-comment-content h6 {
        font-weight: 600;
        margin-top: 1.5rem;
        margin-bottom: 0.75rem;
        color: hsl(var(--foreground));
      }
      .basecamp-comment-content h1 { font-size: 1.5em; }
      .basecamp-comment-content h2 { font-size: 1.25em; }
      .basecamp-comment-content h3 { font-size: 1.125em; }

      /* Basecamp @mentions - reduced to flat inline markup (span > img + text) by
         fixBasecampCommentHtml() before render, since the original
         bc-attachment > figure > figcaption structure gets displaced by the
         browser's HTML parser when a mention appears mid-paragraph (figure is
         block content, invalid inside <p>, so the parser auto-closes the <p>
         around it). See utils/comment-html.ts for the full explanation. */
      .basecamp-todo-description .bc-mention-inline,
      .basecamp-comment-content .bc-mention-inline {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
        vertical-align: middle;
      }
      .basecamp-todo-description .bc-mention-avatar,
      .basecamp-comment-content .bc-mention-avatar {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin: 0;
        vertical-align: middle;
        flex-shrink: 0;
      }
    `}</style>
  );
}

